
























import {Component, Prop, Vue} from 'vue-property-decorator'
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import ImagesStore from '@/store/modules/ImagesStore'

@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DeleteBadgeDialog extends Vue {
    @Prop() private imageId!: number;

    get title(): string {
        const badge = ImagesStore.imageById[this.imageId] || {};
        const badgeName = badge.name || "バッジ";
        return "【 " + badgeName + " 】を削除してもよろしいですか？"
    }
}
